import kaydenceImg from '$/public/artists/kaydence.png'
import subeloNeoImg from '$/public/artists/subelo_neo.jpg'
import tempoeImg from '$/public/artists/tempoe.jpg'

export const testimonials = [
  {
    quote:
      "I picked the 'Circle' loop from the Super Big Black Pack… it became Soweto.",
    author: 'Tempoe',
    position: 'Producer',
    achievements: '500M+ streams, Rema, Don Toliver',
    image: tempoeImg
  },
  {
    quote: 'GRAUX always brings the magic flavors that land placements.',
    author: 'Subelo NEO',
    position: 'Producer',
    achievements: 'Bad Bunny, Karol G',
    image: subeloNeoImg
  },
  {
    quote: "Creativity on demand — that's what these loops feel like.",
    author: 'Kaydence',
    position: 'Producer & Songwriter',
    achievements: 'Ariana Grande, Beyoncé, ZAYN',
    image: kaydenceImg
  }
]
